import React, { useEffect, useState } from 'react';
import { useI18n } from '../context/I18nContext';
import { publicApi } from '../api';
import { staticImg } from '../utils/media';
import { ExternalLink, Award } from 'lucide-react';
import Ornament from './Ornament';

export default function ReferencesSection() {
  const { tr, meta, lang } = useI18n();
  const settings = meta?.settings || {};
  const [items, setItems] = useState([]);

  useEffect(() => {
    let isMounted = true;
    publicApi.references(lang).then((data) => {
      if (isMounted && Array.isArray(data) && data.length > 0) {
        setItems(data);
      }
    }).catch(() => {});
    return () => { isMounted = false; };
  }, [lang]);

  const showRef = settings.show_references;
  if (showRef === '0' || showRef === 0 || showRef === false || showRef === 'false') return null;

  const defaultReferences = [
    { name: 'ValorMT2', title: 'Metin2 PvP Server', logo: 'site_logo_697de09612208.png', url: '#' },
    { name: 'CrimsonMT2', title: 'Hard Emek Server', logo: 'site_logo_697de09612208.png', url: '#' },
    { name: 'IronBlade EU', title: 'Global International', logo: 'site_logo_697de09612208.png', url: '#' },
    { name: 'Astra2 Global', title: 'Orta Emek Server', logo: 'site_logo_697de09612208.png', url: '#' },
  ];

  const list = items.length > 0 ? items : defaultReferences;

  return (
    <section className="relative py-20 lg:py-24 bg-[#09090e] border-y border-white/5 overflow-hidden">
      {/* Background Ambient Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[350px] bg-[#e4b44e]/5 blur-[120px] pointer-events-none rounded-full" />

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <Ornament className="mb-6" />
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#f4d896]/10 border border-[#f4d896]/20 text-[#f4d896] text-xs font-bold tracking-widest uppercase mb-3">
            <Award className="w-3.5 h-3.5" />
            {tr('ref.eyebrow', 'REFERANSLARIMIZ')}
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-black text-white leading-[1.05]">
            <span dangerouslySetInnerHTML={{ __html: tr('ref.title', 'Bizi Tercih Eden <span class="gold-text">Güçlü Projeler</span>') }} />
          </h2>
          <p className="mt-3 text-sm sm:text-base text-white/60">
            {tr('ref.subtitle', 'Aegis Studios altyapısıyla Metin2 dünyasında başarıya ulaşan bazı referans projelerimiz.')}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {list.map((r, i) => {
            const logoVal = r.logo || r.image || r.icon || r.avatar;
            const logoUrl = logoVal ? staticImg(logoVal) : null;
            return (
              <div
                key={r.id || r.name || i}
                className="group relative rounded-2xl border border-white/8 bg-[#0d0d14]/80 backdrop-blur-md p-6 flex flex-col items-center text-center transition-all duration-300 hover:border-[#f4d896]/40 hover:bg-[#12121c] hover:shadow-[0_0_30px_rgba(244,216,150,0.1)]"
              >
                {/* Logo / Image Box */}
                <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl bg-black/40 border border-white/10 p-3 flex items-center justify-center mb-4 group-hover:border-[#f4d896]/40 transition-colors duration-300 relative overflow-hidden">
                  {logoUrl ? (
                    <img
                      src={logoUrl}
                      alt={r.name}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.style.display = 'none';
                        if (e.target.nextSibling) e.target.nextSibling.style.display = 'flex';
                      }}
                      className="max-w-full max-h-full object-contain filter group-hover:brightness-110 transition-all duration-300"
                    />
                  ) : null}
                  <div
                    style={{ display: logoUrl ? 'none' : 'flex' }}
                    className="w-full h-full items-center justify-center font-display font-black text-2xl text-[#f4d896]"
                  >
                    {(r.name || 'R')[0]}
                  </div>
                </div>

                {/* Title & Info */}
                <h3 className="font-display text-lg font-bold text-white group-hover:text-[#f4d896] transition-colors duration-300 mb-1">
                  {r.name || r.title}
                </h3>
                <p className="text-xs text-white/50 mb-3">{r.title || r.description || 'Metin2 Partner'}</p>

                {/* Optional Link */}
                {r.url && r.url !== '#' && (
                  <a
                    href={r.url}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-auto inline-flex items-center gap-1.5 text-[11px] font-bold text-[#f4d896]/80 hover:text-[#f4d896] transition-colors"
                  >
                    <span>{tr('ref.visit', 'Siteyi İncele')}</span>
                    <ExternalLink className="w-3 h-3" />
                  </a>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
